import { useState, useEffect } from 'react';
import {
  Content,
  Table,
  Pagination
} from 'components';
import { styles } from '../styles';
import moment from 'moment';

const SearchedTagList = ({ tagList, selectedTagList, onChangeSelectedTagList }) => {
  const [isCheckedAll, setIsCheckedAll] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const handleCheckedTag = (_, checkedItem) => {
    const isExistTag = selectedTagList.some((tag) => tag.tag_id === checkedItem.tag_id);

    if (isExistTag) {
      onChangeSelectedTagList(selectedTagList.filter(({tag_id}) => tag_id !== checkedItem.tag_id));
    } else {
      if (!Array.isArray(checkedItem)) {
        const newSelectedTagList = selectedTagList.concat([checkedItem]);
        onChangeSelectedTagList(newSelectedTagList);
      }
    }
  }

  const handleCheckedAllTag = (action) => {
    switch (action.type) {
      case 'TOGGLE':  {
        setIsCheckedAll((state) => !state);
        return;
      }
      case 'RESET': {
        setIsCheckedAll(false);
        return;
      }
      default: {
        return;
      }
    }
  }

  const handlePagination = (page) => {
    if (currentPage === page) return;

    setCurrentPage(page);
  };

  useEffect(() => {
    if (isCheckedAll) {
      onChangeSelectedTagList(tagList.map((tag) => tag));
    } else {
      onChangeSelectedTagList([]);
    }
  }, [isCheckedAll])

  return (
    <Content
      maxWidth={'100%'}
      backgroundColor="none"
      padding={0}
      style={{ marginBottom: 20 }}
    >
      <h4 style={{ fontSize: 14, fontWeight: 500, marginBottom: 10 }}>
        검색된 태그 총<span>{tagList.length}</span>건
      </h4>
      <Content maxWidth={'100%'} padding={0} style={{ marginBottom: 20 }}>
        <Table
          isChecked
          pagination={false}
          checkedAll={isCheckedAll}
          checkedList={selectedTagList}
          data={tagList.slice(
            (currentPage - 1) * 10,
            (currentPage - 1) * 10 + 10
          )}
          minHeight={'auto'}
          columns={[
            { title: '태그 번호', key: 'tag_id' },
            {
              title: '태그 명',
              key: 'tag_name',
              render: (item) => (
                <span style={{ ...styles.tag }}>#{item}</span>
              ),
            },
            {
              title: '등록일',
              key: 'created_at',
              render: (item) => moment.unix(item).format('YYYY-MM-DD'),
            },
            {
              title: '수정일',
              key: 'updated_at',
              render: (item) => moment.unix(item).format('YYYY-MM-DD'),
            },
            { title: '노출여부', key: 'is_show' },
            {
              title: '상품 수',
              key: 'products',
              render: (item) => {
                if (Array.isArray(item)) {
                  return `${item.length} EA`
                }
                
                return `0 EA`
              },
            },
          ]}
          onChecked={handleCheckedTag}
          onCheckedAll={handleCheckedAllTag}
        />
        <Pagination 
          current={currentPage}
          pageSize={10}
          total={tagList.length} 
          onChange={handlePagination}
          style={{ marginTop: 20 }} 
        />
      </Content>
    </Content>
  )
}

export default SearchedTagList;